<template>
<div>
  <v-alert
    dense
    border="left"
    :type="notification.type"
    transition="slide-x-transition"
    prominent
    :icon="notification.type == 'warning' ? 'mdi-alert-box' : 'mdi-check'"
    dismissible
  >
    <v-row align="center">
      <v-col class="grow">
        <strong>{{notification.title}}</strong>
      </v-col>
      <v-col class="shrink mr-n1">
        <v-btn icon @click="showNotificationInfo = true">
            <v-icon>mdi-information</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
  <NotificationInfo v-model="showNotificationInfo" :info="notification" />
</div>
</template>

<script>
import NotificationInfo from "./NotificationInfo.vue";
export default {
  name: "Notification",

  props: ["notification"],

  components: {
    NotificationInfo
  },

  data: () => ({
    showNotificationInfo: false,
    timeout: 15000,
  }),
  computed: {},
  methods: {
    //
  },
};
</script>
<style scoped>

</style>
